// Government loans: the funding a student asks for and the amounts HEC approves

export const AMOUNTS = [
  { key: "tuitionFee", label: "Tuition fee", required: true },
  { key: "monthlyLivingAllowance", label: "Monthly living allowance" },
  { key: "researchAllowance", label: "Research allowance" },
  { key: "airTicketAllowance", label: "Air ticket allowance" },
  { key: "medicalInsurance", label: "Medical insurance" },
];

export const formatMoney = (amount, currency) => (amount == null ? "—" : `${currency ?? ""} ${Number(amount).toLocaleString("en-US")}`.trim());

// One line for a table: the tuition, and the living allowance per month when there is one
export const loanSummary = (funding) => {
  if (!funding?.currency || funding.tuitionFee == null) return "Not set";
  const living = funding.monthlyLivingAllowance ? ` + ${Number(funding.monthlyLivingAllowance).toLocaleString("en-US")}/month` : "";
  return `${formatMoney(funding.tuitionFee, funding.currency)}${living}`;
};

// A whole amount from an input, or null when it is empty
export const amountOf = (value) => (value === "" || value == null ? null : Number(value));

// The amounts only (currency and the five allowances), as the award list stores them
export const amountsOf = (funding = {}) => ({ currency: funding?.currency ?? null, ...Object.fromEntries(AMOUNTS.map(({ key }) => [key, funding?.[key] ?? null])) });
